import a1 from './assets/img/avatar-teacher.png'
import a2 from './assets/img/avatar-grown-up.png'
import a3 from './assets/img/avatar-kid.png'

export default [
  a1, a2, a3
]
